module.exports = __webpack_public_path__ + "static/media/Affiche Custom Alhama.648b4dab.jpg";